import React, { useState } from "react";
import useIsLoading from "app/common/custom-hooks/useIsLoading";
import Step1 from "app/pages/auth/_components/_reset-password-steps/Step1";
import Step2 from "app/pages/auth/_components/_reset-password-steps/Step2";
import Step3 from "app/pages/auth/_components/_reset-password-steps/Step3";

const ResetPassword = props => {

    const isLoading = useIsLoading("auth");
    const [stepsData, setStepsData] = useState({step: 1});
    
    const updateProps = {...props, ...stepsData, setStepsData, isLoading};

    return  <div>
                {({
                    "3": <Step3 {...updateProps} />,
                    "2": <Step2 {...updateProps} />
                    })[stepsData.step] ?? <Step1 {...updateProps} />}
            </div>
}

export default ResetPassword;